import {React} from 'common'
import {Colors, Icons} from 'appearance'
import Box from '@mui/material/Box'
import Badge from '@mui/material/Badge'
import Icon from '@mui/material/Icon'
import Avatar from '@mui/material/Avatar'
import {IconButton, styled} from '@mui/material'
import {useGetCurrentUserQuery} from 'store/Store'
import {useDeviceDetect} from 'services/hooks'

const HeaderActions = ({handleOpenMenu}) => {
    const {isMobile} = useDeviceDetect()
    const {data: user} = useGetCurrentUserQuery()
    return (
        <Container>
            <HeaderIconButton
                onClick={handleOpenMenu('notifications')}
                disabled={true}>
                <Badge color="error" overlap="circular" badgeContent={0}>
                    <NotificationsAvatar isMobile={isMobile}>
                        <NotificationsIcon
                            isMobile={isMobile}
                            component={Icons.Notifications}
                        />
                    </NotificationsAvatar>
                </Badge>
            </HeaderIconButton>

            <HeaderIconButton onClick={handleOpenMenu('profile')}>
                <StyledAvatar isMobile={isMobile} src={user?.userPhoto} />
            </HeaderIconButton>
        </Container>
    )
}

export default HeaderActions

const Container = styled(Box)`
    display: flex;
    align-items: center;
    gap: 16px;
`
const StyledAvatar = styled(Avatar)`
    height: ${({isMobile}) => (isMobile ? 31 : 51)}px;
    width: ${({isMobile}) => (isMobile ? 31 : 51)}px;
`
const NotificationsAvatar = styled(StyledAvatar)`
    background: ${Colors.APP_WHITE};
    border: 1px solid #c9c9c9;
`
const NotificationsIcon = styled(Icon)`
    width: ${({isMobile}) => (isMobile ? 21 : 31)}px;
    height: ${({isMobile}) => (isMobile ? 21 : 31)}px;
    color: #818181;
`

const HeaderIconButton = styled(IconButton)`
    padding: 0;
`
